import { getImageUrl } from "@utils/common";

type Mapping = {
  [x: string]: any;
};

export const iconMapping: Mapping = {
  stader: getImageUrl("/assets/images/stader-icon.svg"),
};
